/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './deleteDraft.defs'
export { main as default } from './deleteDraft.defs'
